import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import { CircularProgress, FormHelperText } from "@mui/material";
import { get_root_value } from "src/utils/domUtils";
import { s3baseUrl } from "src/config/config";
import { _get_user_from_localStorage } from "src/DAL/localstorage/LocalStorage";
import { EditProfileApi, GetProfileApi } from "src/DAL/Profile/Profile";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { TimeZones } from "src/utils/constants";

const Input = styled("input")({
  display: "none",
});

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  paper: {
    background: get_root_value("--popup-background-color"),
    color: get_root_value("--input-text-color"),
  },
}));

function EditProfile() {
  const classes = useStyles();
  const { userInfo, setUserInfo, handleSetUserInfo } = useContentSetting();
  const { enqueueSnackbar } = useSnackbar();
  const [previews, setPreviews] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [file, setProfileImage] = useState({});
  const [imageStatus, setImageStatus] = useState(false);
  const [id, setId] = useState();
  const [memberData, setMemberData] = useState({
    address: "",
    biography: "",
    city: "",
    contact_number: "",
    email: "",
    first_name: "",
    image: "",
    last_name: "",
    main_heading: "",
    state: "",
    status: "",
    team_type: "",
    time_zone: "",
  });

  const consultantProfile = async () => {
    const result = await GetProfileApi(userInfo?._id);
    if (result.code === 200) {
      localStorage.setItem("admin_time_zone", JSON.stringify(result.time_zone));
      console.log(result, "fldhskfkjahsd");
      handleSetUserInfo(result.coach);
      setMemberData(result.coach);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    formData.append("first_name", memberData.first_name);
    formData.append("last_name", memberData.last_name);
    formData.append("email", memberData.email);
    formData.append("city", memberData.city);
    formData.append("time_zone", memberData.time_zone);
    formData.append("state", memberData.state);
    formData.append("address", memberData.address);
    formData.append("biography", memberData.biography);
    formData.append("contact_number", memberData.contact_number);
    if (imageStatus === true) {
      formData.append("image", file);
    }

    const result = await EditProfileApi(id, formData);
    if (result.code === 200) {
      setUserInfo(result.coach);
      localStorage.setItem(`user_data`, JSON.stringify(result.coach));
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setIsLoading(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(value, "value of edit profile");
    setMemberData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleUpload = (event) => {
    setImageStatus(true);
    setProfileImage(event.target.files[0]);
    const preview = URL.createObjectURL(event.target.files[0]);
    setPreviews(preview);
  };

  useEffect(() => {
    setMemberData(userInfo);
  }, []);

  useEffect(() => {
    consultantProfile();
  }, []);

  useEffect(() => {
    setId(userInfo?._id);
  }, [userInfo?._id]);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container ">
      <form onSubmit={handleUpdate}>
        <div className="mt-4 mb-4 d-flex justify-content-center">
          <div className="cards-edit p-4">
            <div className=" image d-flex flex-column justify-content-center align-items-center">
              <div className="edit-profile-icon">
                <img
                  src={
                    previews
                      ? previews
                      : s3baseUrl + userInfo?.image?.thumbnail_1
                  }
                  height="100"
                  width="100"
                />
                <label htmlFor="icon-button-file">
                  <Input
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    name="profile_image"
                    onChange={(e) => handleUpload(e)}
                  />
                  <IconButton
                    className="edit-profile-icon-position"
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                  >
                    <PhotoCamera />
                  </IconButton>
                </label>
              </div>
              <div className="row w-100 mt-3">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="First Name"
                      variant="outlined"
                      fullWidth
                      size="small"
                      name="first_name"
                      value={memberData.first_name}
                      onChange={(e) => handleChange(e)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Last Name"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={memberData.last_name}
                      name="last_name"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Email"
                      type="email"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={memberData.email}
                      name="email"
                      onChange={(e) => handleChange(e)}
                      required={true}
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Contact Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={memberData.contact_number}
                      name="contact_number"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Address"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={memberData.address}
                      name="address"
                      onChange={(e) => handleChange(e)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="City"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={memberData.city}
                      name="city"
                      onChange={(e) => handleChange(e)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="State/County"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={memberData.state}
                      name="state"
                      onChange={(e) => handleChange(e)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="mt-4">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Timezone
                      </InputLabel>
                      <Select
                        MenuProps={{
                          classes: {
                            paper: classes.paper,
                          },
                        }}
                        className="svg-color"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={memberData.time_zone}
                        name="time_zone"
                        label="Timezone"
                        onChange={handleChange}
                        size="small"
                        sx={{
                          color: get_root_value("--input-text-color"),
                        }}
                      >
                        {TimeZones.map((value, i) => {
                          return <MenuItem value={value}>{value}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="mt-4 textarea-block">
                    <TextField
                      id="outlined-basic"
                      label="Biography"
                      variant="outlined"
                      rows={4}
                      multiline
                      fullWidth
                      size="small"
                      value={memberData.biography}
                      inputProps={{
                        maxLength: 500,
                      }}
                      name="biography"
                      onChange={(e) => handleChange(e)}
                    />
                    <FormHelperText>
                      Maximum limit 500 characters
                    </FormHelperText>
                  </div>
                </div>
              </div>
              <div className="mt-2 ms-auto">
                <button className="small-contained-button mt-4 ">Update</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditProfile;
